import { WithImaSdk } from './sdk';
import { ImaActions } from './actions';
import { AssetType, AdType, } from '../..';
export const WithIma = (Base, ImaSDK, Actions) => {
    const WithCustomImaSdk = ImaSDK ?? WithImaSdk;
    return class AdapterWithImaSdk extends WithCustomImaSdk(Base) {
        actions = new (Actions ?? ImaActions)(this);
        isAdPlaying() {
            return this.actions.isAdPlaying();
        }
        async load(request) {
            this.actions.loadNewSession(
            // TODO: I'm not sure why this needs to be muted if it's Live.
            //  What will happen after channel switch?
            request.playOptions.assetInfo.assetType === AssetType.LIVE);
            const media = await super.load(request);
            const ads = request.playOptions.adsInfo;
            let ad;
            if (ads?.preroll) {
                ad = {
                    type: ads.preroll.isChannelAd ? AdType.START : AdType.PREROLL,
                    ...ads.preroll,
                };
            }
            if (ads?.midroll) {
                ad = {
                    type: AdType.MIDROLL,
                    ...ads?.midroll,
                };
            }
            if (ad) {
                this.loadVast(ad);
            }
            return media;
        }
        setVolume(volume) {
            if (this.actions.isAdPlaying()) {
                this.actions.recoverVolume = volume;
                this.imaSetVolume(volume);
            }
            if (!this.actions.isAdPlaying() || this.actions.isReusingAdapter()) {
                super.setVolume(volume);
            }
        }
        play() {
            if (this.actions.isAdPlaying()) {
                this.imaPlay();
            }
            if (!this.actions.isAdPlaying() || this.actions.isReusingAdapter()) {
                super.play();
            }
        }
        pause() {
            if (this.actions.isAdPlaying()) {
                this.imaPause();
            }
            if (!this.actions.isAdPlaying() || this.actions.isReusingAdapter()) {
                super.pause();
            }
        }
        stop() {
            if (this.actions.isAdPlaying()) {
                this.imaStop();
            }
            return super.stop();
        }
    };
};
